export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0067.d2ee7502.webp";